// errors
export const ERROR_TECNICO = "error-1";
export const INDIVIDUO_NEGATIVO = "error-2";
export const RECHAZADO_OTROS = "error-3";
export const ERROR_NOSIS = "error-4";
export const RECHAZADO = "error-5";
export const CLIENTE_ENCONTRADO = "error-6";
export const CLIENTE_FINANCIADO = "error-7";
export const CUIT_NOVALIDA = "error-8";
export const USUARIO_BLOQUEADO = "error-9";
export const GRACIAS = "gracias";
